import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import classnames from 'classnames';
import ShipmentDetailsStyles from '../../pages/shipment/__styles__/ShipmentDetails.styles';
import ShipmentHeaderStyles from '../../components/shipment/__styles__/ShipmentHeader.styles';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';
import BackIcon from '@material-ui/icons/NavigateBefore';
import { formatInvoice } from '../../pages/invoice/InvoiceHelpers';
import { AppContext } from '../../AppProvider';
import ButtonBar from './ButtonBar';

const styles = theme => ({
  rejectText: {
    color: '#F22D12',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'bold !important'
  },
  headerRoot: {
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)'
  },
  invoiceDetails: {
    alignItems: 'center',
    display: 'flex',
    minHeight: 84,
    flexWrap: 'wrap',
    padding: [[0, theme.spacing.unit * 9]],
    position: 'relative',
    '&:first-child': {
      borderBottom: '1px solid rgba(12,31,44,0.12)'
    }
  },
  backButton: {
    position: 'absolute',
    left: 16
  },
  invoiceNumber: {
    marginRight: [theme.spacing.unit, '!important']
  },
  invoiceStatus: {
    borderRadius: 18,
    height: 36,
    padding: [[0, theme.spacing.unit * 1.5]],
    display: 'flex',
    alignItems: 'center',
    marginLeft: [theme.spacing.unit * 2, '!important'],
    fontWeight: ['bold', '!important']
  },
  inReview: {
    backgroundColor: '#EBEFF3',
    color: ['rgba(12,31,44,0.54)', '!important']
  },
  error: {
    backgroundColor: '#FDE5E2',
    color: ['#F22D12', '!important']
  },
  invoiceDetailItem: {
    marginRight: [theme.spacing.unit * 8, '!important'],
    '&:last-child': {
      marginRight: 0
    }
  },
  invoiceDetailAttribute: {
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  }
});

const INVOICE_DETAILS_ATTRS = ({ t }) => [
  { value: 'variance', title: t('Variance') },
  { value: 'carrierName', title: t('Carrier Name') },
  { value: 'carrierInvoiceNumber', title: t('Carrier Invoice #') },
  { value: 'invoiceDate', title: t('Invoice Date') },
  { value: 'dueDate', title: t('Due Date') }
];

export class InvoiceHeader extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired
  };

  state = {
    anchorEl: null,
    moreMenuOpen: false,
    assignModalOpen: false
  };

  _handleAssignShipmentClick = () => {
    this.setState({ assignModalOpen: true });
  };
  _handleCloseAssignModal = () => {
    this.setState({ assignModalOpen: false });
  };
  // _onAssignShipment = (shipmentId) => {
  _onAssignShipment = () => {
    this.setState({ assignModalOpen: false });
    // TODO - implement the assign
  };

  _onBackClick = () => {
    const { history } = this.props;
    history.push('/invoices');
  };

  _handleOpenShipment = () => {
    // open the shipment detail in another window/tab
    window.open('/shipments/' + this.props.invoice.shipmentId);
  };

  render() {
    const { classes, t, invoice } = this.props;
    const formattedInvoice = formatInvoice(
      invoice,
      this.context.globalProps.orgInfo.config.defaultCurrency
    );

    return (
      <section className={classes.headerRoot}>
        <div className={classes.invoiceDetails}>
          <IconButton
            onClick={this._onBackClick}
            color={'primary'}
            className={classes.backButton}
          >
            <BackIcon />
          </IconButton>
          <h1 className={classnames(classes.headline5, classes.invoiceNumber)}>
            {t('Invoice')} #{formattedInvoice.id}
          </h1>
          <p
            className={classnames(
              classes.invoiceStatus,
              classes.body2,
              classes.noMarginBottom,
              classes.inReview
            )}
          >
            {formattedInvoice.displayStatus}
          </p>
          <div className={classes.spacer} />
          <ButtonBar invoice={invoice} />
        </div>
        <div className={classes.invoiceDetails}>
          <p
            className={classnames(classes.headline6, classes.invoiceDetailItem)}
          >
            {formattedInvoice.invoiced}
          </p>
          {INVOICE_DETAILS_ATTRS({ t }).map(invoiceDetail => (
            <div
              className={classes.invoiceDetailItem}
              key={invoiceDetail.value}
            >
              <p
                className={classnames(
                  classes.subtitle3,
                  classes.invoiceDetailAttribute
                )}
              >
                {invoiceDetail.title}
              </p>
              <p className={classes.body2}>
                {formattedInvoice[invoiceDetail.value]}
              </p>
            </div>
          ))}
          <Button
            className={classes.button}
            classes={{
              label: classes.buttonLabel
            }}
            variant="contained"
            color="primary"
            onClick={null}
          >
            {t('Assign to Shipment')}
          </Button>
        </div>
      </section>
    );
  }
}

InvoiceHeader.contextType = AppContext;
const headerStyled = withStyles(
  //combineStyles(ShipmentHeaderStyles, ButtonStyles, SpacingStyles)
  combineStyles(
    styles,
    ShipmentHeaderStyles,
    ShipmentDetailsStyles,
    ButtonStyles,
    SpacingStyles,
    TypographyStyles
  )
)(InvoiceHeader);
const translatedInvoiceHeader = withNamespaces()(headerStyled);
export default withRouter(translatedInvoiceHeader);
